import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

type KommTyp = { id: number; code: string; label: string; icon: string | null; sort_order: number };
type LookupResponse<T> = { type: string; items: T[] };

export function useKommunikationsTypen() {
  return useQuery({
    queryKey: ['lookups', 'kommunikation_typen'],
    queryFn: () =>
      apiFetch<LookupResponse<KommTyp>>('/lookups.php?type=kommunikation_typen'),
    staleTime: 10 * 60_000
  });
}
